import Agende from "../";

const routes = [
    { name: "AgendeListPage", path: "/agende", component: Agende.AgendeListPage, meta: { title: "Lista Agende" } },
    { name: "AgendaEditPage", path: "/agende/edit/:id", component: Agende.AgendaEditPage, meta: { title: "Crea/Modifica Agenda" } },
    { name: "AgendaView", path: "/agende/view/:id", component: Agende.AgendaViewPage, meta: { title: "Dettaglio Agenda" } },
];

export default routes;
